export enum SCENES_ACTIONS {
    TRACK_CHANGED_SCENE_DESIGN = 'TRACK_CHANGED_SCENE_DESIGN',
    CLEAR_TRACKED_SLIDE = 'CLEAR_TRACKED_SLIDE',
    HIDE_SCENE_SECTIONS = 'HIDE_SCENE_SECTIONS',
    SET_SCENE_SELECTOR_SLIDE_ID = 'SET_SCENE_SELECTOR_SLIDE_ID',
    SET_OVERLAY_SELECTOR_SCENE_GROUP_ID = 'SET_OVERLAY_SELECTOR_SCENE_GROUP_ID',
    SET_SWAP_SCENE_DESIGN_SLIDE_ID = 'SET_SWAP_SCENE_DESIGN_SLIDE_ID',
    SHOW_FULLSCREEN_SELECTOR = 'SHOW_FULLSCREEN_SELECTOR',
    HIDE_FULLSCREEN_SELECTOR = 'HIDE_FULLSCREEN_SELECTOR',
    SHOW_FULLSCREEN_SWAP_SCENE_SELECTOR = 'SHOW_FULLSCREEN_SWAP_SCENE_SELECTOR',
    HIDE_FULLSCREEN_SWAP_SCENE_SELECTOR = 'HIDE_FULLSCREEN_SWAP_SCENE_SELECTOR',
    SHOW_OVERLAY_SELECTOR = 'SHOW_OVERLAY_SELECTOR',
    HIDE_OVERLAY_SELECTOR = 'HIDE_OVERLAY_SELECTOR',
    SET_ACTIVE_OVERLAY = 'SET_ACTIVE_OVERLAY',
    CLEAR_ACTIVE_OVERLAY = 'CLEAR_ACTIVE_OVERLAY',
    TRACK_SLIDE_TEXT_ASSET = 'TRACK_SLIDE_TEXT_ASSET',
    TRACK_SLIDE = 'TRACK_SLIDE',
    CLEAR_TRACKED_SLIDE_TEXT_ASSETS = 'CLEAR_TRACKED_SLIDE_TEXT_ASSETS',
    CLEAR_TEXT_ASSET_TRACKED_SLIDE = 'CLEAR_TEXT_ASSET_TRACKED_SLIDE',
    SET_FOCUSED_ASSET = 'SET_FOCUSED_ASSET',
    CLEAR_CURRENTLY_EDITING_ASSET = 'CLEAR_CURRENTLY_EDITING_ASSET',
    SELECT_SCENE = 'SELECT_SCENE',
    CLEAR_SCENE = 'CLEAR_SCENE',
    UPDATE_CACHED_SCENE_TEXT_FOR_MEDIA_QUERY = 'UPDATE_CACHED_SCENE_TEXT_FOR_MEDIA_QUERY',
    SET_CURRENTLY_EDITING_SCENE = 'SET_CURRENTLY_EDITING_SCENE',
}

export type OverlayBounds = {
    startTime: number | null;
    endTime: number | null;
};
